export default function sortPackages(packages, orderBy, order) {
  return (order === 'desc')
			? packages.sort((a, b) => { 
				if (a[orderBy].value) return (b[orderBy].value < a[orderBy].value ? -1 : 1);
				else return (b[orderBy] < a[orderBy] ? -1 : 1);
			}) : packages.sort((a, b) => {
				if (a[orderBy].value) return (a[orderBy].value < b[orderBy].value ? -1 : 1);
				else return (a[orderBy] < b[orderBy] ? -1 : 1);
			});
}